module.exports = __webpack_public_path__ + "img/server.svg";